import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { PaginationMetadata, } from "../../Types";
import ValidationError from "../../ZodError";
import { PortfolioAssignment } from "../types";
export const portfolioAssignmentsURL = (abstractPortfolioId, queryString) => {
    const qs = new URLSearchParams();
    if (queryString?.accountOwnedBy !== undefined) {
        qs.append("accountOwnedBy", queryString.accountOwnedBy);
    }
    const qsString = `?${qs.toString()}`; // notice the leading `?` character
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/investment/portfolio-plans/${abstractPortfolioId}/assignment${qsString}`
        : `https://middleware.uat.farther.com/investment/portfolio-plans/${abstractPortfolioId}/assignment${qsString}`;
};
const PortfolioAssignmentResponse = z.object({
    data: PortfolioAssignment.array(),
    pagination: PaginationMetadata,
});
export const getPortfolioPlanAssignments = async (params, config) => {
    const { data } = await axios.get(portfolioAssignmentsURL(params.abstractPortfolioId, params.queryString ?? null), {
        headers: {
            version: "20240903",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = PortfolioAssignmentResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getAssignments.ts] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getPortfolioPlanAssignments.js.map